"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.documentOwnerEntityTypeSchema = exports.DOCUMENT_OWNER_ENTITY_TYPES = void 0;
exports.documentOwnerIdFormatError = documentOwnerIdFormatError;
const zod_1 = require("zod");
const bl_order_id_1 = require("./bl-order-id");
exports.DOCUMENT_OWNER_ENTITY_TYPES = [
    'bl_order',
    'order',
    'company',
    'ticket',
    'bl_container',
    'invoice',
    'claim',
    'other_cost_invoice',
];
exports.documentOwnerEntityTypeSchema = zod_1.z.enum(exports.DOCUMENT_OWNER_ENTITY_TYPES);
const uuidOwnerIdSchema = zod_1.z.string().uuid();
// claim and other_cost_invoice are uuid-keyed; every other host id is a bigint serialised as text.
const UUID_KEYED_OWNERS = new Set([
    'claim',
    'other_cost_invoice',
]);
function documentOwnerIdFormatError(ownerEntityType, ownerEntityId) {
    if (UUID_KEYED_OWNERS.has(ownerEntityType)) {
        return uuidOwnerIdSchema.safeParse(ownerEntityId).success
            ? null
            : `${ownerEntityType} owner ids must be a uuid; received '${ownerEntityId}'`;
    }
    return bl_order_id_1.blOrderIdSchema.safeParse(ownerEntityId).success
        ? null
        : `${ownerEntityType} owner ids must be a numeric bigint-as-text id; received '${ownerEntityId}'`;
}
//# sourceMappingURL=document-owner.js.map